import React from "react";
import ValuesFields from "./ValuesFields";
import { useScrollToElement } from "utils/hooks/editor";

/**
 * Form: src/components/Form/Components/Legal/index.jsx
 */
const LegalFields = ({ name }) => {
  useScrollToElement(name);

  return (
    <div className="ph3">
      <ValuesFields name={name} />
    </div>
  );
};

export default LegalFields;
